/**
 * @file CompilationGrid.types.ts
 */

import type { PickAnalytic } from '@shared/api/analytics/types/types'
import type { TypeNewsCardData } from '@shared/api/middleware/mappingAPI/news/viewModel'
import type { TypeMappingSelectionOutput } from '@shared/api/middleware/mappingAPI/selection/type'

export type PropsBase = {
  counts: string // example - '6 4 4' (desktop-large, desktop-medium, tablet)
  className?: string
  analytic: {
    section_name: string
    analytic_indexes?: number[]
  }
  skeleton?: boolean
}

export const compilationGridTypeSelections = 'selections' as const
export const compilationGridTypeNews = 'news' as const

export type Props =
  | (PropsBase & { type: typeof compilationGridTypeSelections; list: TypeMappingSelectionOutput[] })
  | (PropsBase & { type: typeof compilationGridTypeNews; list: TypeNewsCardData[] })

export type RenderCardCardProps = {
  style?: object
  sizes: string | null
  className: string
  analytic: PickAnalytic<'section_index' | 'section_name'>
}

export type BuildCompilationGridCardPropsParams = {
  index: number
  visibleCount: number
  countsMode: string
  listLength: number
  analytic: PropsBase['analytic']
}

export type RenderCardParams =
  | { type: typeof compilationGridTypeSelections; item: TypeMappingSelectionOutput; cardProps: RenderCardCardProps }
  | { type: typeof compilationGridTypeNews; item: TypeNewsCardData; cardProps: RenderCardCardProps }
